export const _getEmptyGridLayerElThrowable = (self) => {
  if (self._empty_grid_layer_el == null) {
    throw new Error(
      `empty_grid_layer 엘리먼트가 없습니다. DOM 초기화를 진행해주세요.`
    );
  }
  return self._empty_grid_layer_el;
};
